import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveConstraintsRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveConstraintsRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveConstraintsRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getConstraints() {
      return getState().constraints;
    },
  };
}

export { createSelector };
